import { render, staticRenderFns } from "./DataTableOrder.vue?vue&type=template&id=5ad0017d&scoped=true&"
import script from "./DataTableOrder.vue?vue&type=script&lang=js&"
export * from "./DataTableOrder.vue?vue&type=script&lang=js&"
import style0 from "./DataTableOrder.vue?vue&type=style&index=0&id=5ad0017d&prod&lang=scss&"
import style1 from "./DataTableOrder.vue?vue&type=style&index=1&id=5ad0017d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad0017d",
  null
  
)

export default component.exports